var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarclose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.901 21.4111C17.224 21.734 17.7552 21.734 18.0781 21.4111C18.401 21.0882 18.401 20.557 18.0781 20.234L11.1771 13.333L18.0781 6.43197C18.401 6.10905 18.401 5.5778 18.0781 5.25488C17.7552 4.93197 17.224 4.93197 16.901 5.25488L10 12.1559L3.09896 5.25488C2.77604 4.93197 2.24479 4.93197 1.92187 5.25488C1.59896 5.5778 1.59896 6.10905 1.92187 6.43197L8.82292 13.333L1.92187 20.234C1.59896 20.557 1.59896 21.0882 1.92187 21.4111C2.24479 21.734 2.77604 21.734 3.09896 21.4111L10 14.5101L16.901 21.4111Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarclose);
export default __webpack_public_path__ + "static/media/sidebarclose.fb24a260ac9f1919b183f758bb2bf162.svg";
export { ForwardRef as ReactComponent };